export type AppThemeId =
  | "electrical"
  | "electrical_us"
  | "ibew_aptitude"
  | "plumbing"
  | "plumbing_us";

export interface AppTheme {
  brand: string;
  brandButton: string;
  brandDeep: string;
  brandHover: string;
  brandSoft: string;
  paywallBackground: string;
  primaryHsl: string;
  studyJourney: string;
}

const GREEN_THEME: AppTheme = {
  brand: "#43b047",
  brandButton: "#5db075",
  brandDeep: "#123b26",
  brandHover: "#4d9f68",
  brandSoft: "#eaf6ee",
  paywallBackground:
    "linear-gradient(180.117deg, #dcefe3 0.155%, #f2f9f4 69.245%, #ffffff 112.28%)",
  primaryHsl: "137 35% 53%",
  studyJourney: "Red Seal",
};

const PLUMBING_THEME: AppTheme = {
  brand: "#e06438",
  brandButton: "#e76036",
  brandDeep: "#762b08",
  brandHover: "#cc512b",
  brandSoft: "#fbece7",
  paywallBackground:
    "linear-gradient(180.117deg, #fbece7 0.155%, #fbece7 69.245%, #ffffff 112.28%)",
  primaryHsl: "14 79% 56%",
  studyJourney: "Red Seal",
};

const APP_THEMES: Record<AppThemeId, AppTheme> = {
  electrical: GREEN_THEME,
  electrical_us: { ...GREEN_THEME, studyJourney: "NEC" },
  ibew_aptitude: { ...GREEN_THEME, studyJourney: "IBEW Aptitude" },
  plumbing: PLUMBING_THEME,
  plumbing_us: PLUMBING_THEME,
};

export function getAppTheme(app: AppThemeId) {
  return APP_THEMES[app];
}
